import { resetMapOptions, selectMapOptions, updateMapOption } from 'containers/Maps/Map/mapSlice'
import { selectLocation, updateLocation } from 'containers/Maps/menu/filtersSlice'
import LanguageSelect from 'layouts/Desktop/components/Navbar/LanguageSelect'
import { DISTANCE_LIST } from 'containers/Maps/Map/mapUtils'
import { useReduxDispatch, useReduxSelector } from 'store'
import LocationSelect from 'components/LocationSelect'
import ArrowBtn from 'components/buttons/ArrowBtn'
import useTranslation from 'hooks/useTranslation'
import { useHistory } from 'react-router-dom'
import Select from 'components/inputs/Select'
import mmbox from 'assets/img/htbox1.png'
import React from 'react'

const type = process.env.REACT_APP_TYPE

const Header: React.FC = () => {
  const mapOptions = useReduxSelector(selectMapOptions)
  const location = useReduxSelector(selectLocation)

  const { t } = useTranslation('onePage')
  const dispatch = useReduxDispatch()
  const { push } = useHistory()

  return (
    <div className='onePage__header'>
      <div className='onePage__header__nav'>
        <div className='onePage__header__nav__logo'>
          {type === 'mm'
            ? <>
              <i className='icon icon--logo s24' />
              <span className='--secFont'>Magazynomaty</span>
            </>
            : <i className={`icon icon--${type}-full-logo`} />}
        </div>
        <div className='onePage__header__nav__links'>
          <LanguageSelect />
          <ArrowBtn
            enlarged
            showArrow={false}
            text={t('partnerZone')}
            className='--dashed'
            action={() => {
              alert('Partner zone is currently unavailable. Please contact us if you are interested in cooperation.')
            }}
          />
          <ArrowBtn
            enlarged
            showArrow={false}
            className='--onlyDesktop'
            text={t('rentStorage')}
            action={() => {
              push('/map')
            }}
          />
        </div>
      </div>

      <div className='onePage__header__main'>
        <div className='onePage__header__content'>
          <h3>{t('selfStorageRental')}</h3>
          <h1>{t('selfStorageUnits')}</h1>
          <div className='onePage__header__content__search'>
            <LocationSelect
              showIcon
              label={false}
              address={location}
              placeholder={t('city')}
              voivodship={mapOptions.voivodship}
              clearAddress={() => {
                dispatch(resetMapOptions())
                dispatch(updateLocation(''))
              }}
              setAddress={(address, mapOption) => {
                dispatch(updateLocation(address))
                dispatch(updateMapOption(mapOption))
              }}
            />
            <Select
              value={mapOptions.distance || DISTANCE_LIST[0]}
              options={DISTANCE_LIST.map(value => ({ value, name: `${value} km` }))}
              setValue={value => {
                dispatch(updateMapOption({ distance: value }))
              }}
            />
            <ArrowBtn
              enlarged
              showArrow={false}
              text={t('search')}
              action={() => {
                push('/map')
              }}
            />
          </div>
          <div className='onePage__header__content__details'>
            <div className='onePage__header__content__detail'>
              <i className='icon icon--calendar-bold cWhite' />
              <span>{t('rentalFromOneDay')}</span>
            </div>
            <div className='onePage__header__content__detail'>
              <i className='icon icon--time cWhite' />
              <span>{t('access247')}</span>
            </div>
          </div>
        </div>
        <img
          alt='storage'
          className='--htbox --reverse'
          src={mmbox}
        />
      </div>
    </div>
  )
}

export default Header